export default __webpack_public_path__ + "static/media/partner-13.88398a21.svg";